module.exports = __webpack_public_path__ + "assets/img/wback5.2327818d.png";